/* @flow */
import MenuItem from 'components/MenuItem.jsx';
import ModalTrigger from 'components/ModalTrigger.jsx';
import PropTypes from 'prop-types';
import * as React from 'react';

class ModalMenuItem extends React.Component<$FlowFixMeProps> {
  static propTypes = {
    modal: PropTypes.node.isRequired,
    disabled: PropTypes.bool,
  };

  static defaultProps = {
    disabled: false,
  };

  render() {
    let menuItem = <MenuItem {...this.props}>{this.props.children}</MenuItem>;

    if (!this.props.disabled) {
      menuItem = <ModalTrigger modal={this.props.modal}>{menuItem}</ModalTrigger>;
    }

    return menuItem;
  }
}

export default ModalMenuItem;
